module.exports = __webpack_public_path__ + "img/success.e3b464e2.svg";